import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AppProvider, useApp } from '@/context/AppContext';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import CommandCenter from '@/pages/CommandCenter';
import BrainDump from '@/pages/BrainDump';
import Pipeline from '@/pages/Pipeline';
import ProductDetail from '@/pages/ProductDetail';
import Creatives from '@/pages/Creatives';
import Metrics from '@/pages/Metrics';
import Tasks from '@/pages/Tasks';
import TimeTracker from '@/pages/TimeTracker';
import Assistant from '@/pages/Assistant';
import SOPs from '@/pages/SOPs';
import Settings from '@/pages/Settings';
import VideoBackground from '@/components/VideoBackground';
import { CustomCursor } from '@/components/CustomCursor';
import '@/App.css';

const Protected = ({ children }) => {
  const { authed } = useApp();
  if (!authed) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><CommandCenter /></Protected>} />
      <Route path="/brain-dump" element={<Protected><BrainDump /></Protected>} />
      <Route path="/pipeline" element={<Protected><Pipeline /></Protected>} />
      <Route path="/products/:id" element={<Protected><ProductDetail /></Protected>} />
      <Route path="/creatives" element={<Protected><Creatives /></Protected>} />
      <Route path="/metrics" element={<Protected><Metrics /></Protected>} />
      <Route path="/tasks" element={<Protected><Tasks /></Protected>} />
      <Route path="/time" element={<Protected><TimeTracker /></Protected>} />
      <Route path="/assistant" element={<Protected><Assistant /></Protected>} />
      <Route path="/sops" element={<Protected><SOPs /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <VideoBackground />
        <AppRoutes />
        <Toaster position="top-right" richColors closeButton />
        <CustomCursor />
      </BrowserRouter>
    </AppProvider>
  );
}
